export class Administrador{
    id: number;
    nome: string;
    email: string;
    upn: string;
}